import { NUMBER_THEN_STREET, STREET_THEN_NUMBER } from '@/constants/addressFormat';
import { MapPinEnum } from '@desquared/wave-components-library';

export function formatAddress(address = {}, t, addressFormat = NUMBER_THEN_STREET) {
  const trim = v => (v ?? '').toString().trim();
  const street = trim(address.street);
  const streetNo = trim(address.streetNo);

  let streetLine = '';
  if (street || streetNo) {
    streetLine =
      addressFormat === STREET_THEN_NUMBER
        ? [street, streetNo].filter(Boolean).join(' ')
        : [streetNo, street].filter(Boolean).join(' ');
  }

  const locality = [trim(address.city), trim(address.postalCode)].filter(Boolean).join(', ');

  const line1 = [streetLine, locality].filter(Boolean).join(', ');

  const labelFloor = t ? t('user_address.subtitle.floor') : 'Όροφος';
  const labelBell = t ? t('user_address.subtitle.door_bell') : 'Κουδούνι';

  const extras = [];
  if (trim(address.floor)) extras.push(`${labelFloor}: ${trim(address.floor)}`);
  if (trim(address.nameAtBell)) extras.push(`${labelBell}: ${trim(address.nameAtBell)}`);

  const line2 = extras.length ? extras.join(', ') : '';
  const line3 = trim(address.contactPhone);

  return [line1, line2, line3].filter(Boolean).join('\n');
}

export function getAddressTypeInfo(type, t) {
  switch (type) {
    case 'work':
      return { label: t ? t('user_address.types.work') : 'Εργασία' };
    case 'other':
      return { label: t ? t('user_address.types.other') : 'Άλλο' };
    default:
      return { label: t ? t('user_address.types.default') : 'Σπίτι' };
  }
}
export function getAddressList(
  addresses,
  onEdit,
  onDelete,
  onNewAddress,
  isMobile,
  mainAddress,
  t,
  addressFormat = NUMBER_THEN_STREET
) {
  const list = [];
  addresses.map((item, index) => {
    let myType;
    switch (item.type) {
      case 'home':
        myType = 'Home';
        break;
      case 'other':
        myType = 'Other';
        break;
      case 'work':
        myType = 'Work';
        break;
    }
    const newAddress = {
      isMainAddress: mainAddress._id === item._id,
      title: getAddressTypeInfo(item.type, t).label,
      type: myType,
      subtitle: formatAddress(item, t, addressFormat),
      onEdit: () => {
        onEdit(item._id);
      },
      onDelete: () => {
        onDelete(item._id);
      },
      isAddNew: false,
    };
    list.push(newAddress);
  });
  if (list.length > 0 && !isMobile) {
    const newAddress = {
      title: t ? t('user_address.add') : 'Προσθήκη Νέας Διεύθυνσης',
      type: 'Other',
      onEdit: () => {},
      onDelete: () => {},
      isAddNew: true,
      onAdd: () => {
        onNewAddress();
      },
    };
    list.push(newAddress);
  }
  return list[0] ? list : list[0];
}

export function transformToStigmas(inputArray) {
  const stigmas = inputArray.map(obj => {
    const { address } = obj;
    return {
      postal: address.postalCode,
      lat: address.latitude,
      lng: address.longitude,
      pin: MapPinEnum.Wave,
    };
  });

  return stigmas;
}

export const getAddressType = addressType => {
  switch (addressType) {
    case 0:
      return 'home';
    case 1:
      return 'work';
    case 2:
      return 'other';
  }
};

export default { formatAddress, getAddressTypeInfo, getAddressList, transformToStigmas, getAddressType };
